(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9597],{

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 4796:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experiences",
      function () {
        return __webpack_require__(4988);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const FAQs = (props)=>{
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const contentRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const faqs = props === null || props === void 0 ? void 0 : props.faqsData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        contentRefs.current = contentRefs.current.slice(0, faqs.length);
    }, [
        faqs
    ]);
    const toggleAccordion = (index)=>{
        setOpenIndex(openIndex === index ? null : index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "destination_faqs row justify-content-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "col-12 col-sm-12 col-md-8 col-lg-8",
            children: faqs.map((item, index)=>{
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "accordion",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "accordion__title",
                            onClick: ()=>toggleAccordion(index),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                    children: [
                                        " ",
                                        item.accordionQuestion
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "accordion_btn",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "arrow_btn ".concat(openIndex === index ? "rotate" : ""),
                                        "aria-label": "Accordion Button",
                                        children: openIndex === index ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "20px",
                                            viewBox: "0 -960 960 960",
                                            width: "20px",
                                            fill: "#000000",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M232-444v-72h496v72H232Z"
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "24px",
                                            viewBox: "0 -960 960 960",
                                            width: "20px",
                                            fill: "#000000",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: (el)=>contentRefs.current[index] = el,
                            className: "accordion__content ".concat(openIndex === index ? "accordion__content--open" : ""),
                            style: openIndex === index ? {
                                maxHeight: contentRefs.current[index] ? contentRefs.current[index].scrollHeight : "none"
                            } : {
                                maxHeight: 0
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: item.accordionAnswer
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(FAQs));


/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9262);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Topbanner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container common_title text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: props.title
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 4988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Experiences; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8041);
/* harmony import */ var _styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Topbanner_Topbanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6240);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6066);
/* harmony import */ var _components_Faqs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4264);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7349);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7803);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_9__);












function Experiences() {
    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const experiences = [
        {
            title: "Mahasu Peak",
            description: "Mahasu Peak is the highest point in Kufri, offering breathtaking views of the Himalayas. The trek to the peak is an adventure, surrounded by lush pine forests. It’s an ideal spot for photography and nature lovers. The panoramic vistas are especially stunning at sunrise and sunset. You can also spot various bird species here, making it a great place for birdwatching. A visit to Mahasu Peak is a must for anyone seeking natural beauty.",
            image: "/images/experience/mahasu.png",
            alt: "Mahashu Peak",
            textFirst: false
        },
        {
            title: "The Himalayan Nature Park",
            description: "The Himalayan Nature Park is a peaceful retreat that showcases the region's diverse flora and fauna. It features beautiful walking trails where you can enjoy the serene environment and spot native animals. The park is home to various species of trees, plants, and wildlife, making it perfect for nature walks. You can also learn about the local ecosystem through informative displays. A visit here allows you to connect with nature and enjoy the tranquil surroundings.",
            image: "/images/experience/himalayan-nature-park-kufri.png",
            alt: "The Himalayan Nature Park",
            textFirst: true
        },
        {
            title: "Fagu",
            description: "Fagu is a charming village near Kufri known for its stunning apple orchards and picturesque landscapes. It offers a tranquil escape from the bustling city life. The views of snow-capped mountains and lush greenery are breathtaking, especially during the autumn months when the leaves change colors. Fagu is a great spot for picnics and leisurely walks. Visitors can also explore the local culture and enjoy the hospitality of the villagers while savoring fresh apple produce.",
            image: "/images/experience/fagu.png",
            alt: "Fagu",
            textFirst: false
        },
        // {
        //     title: "Kufri Zoo",
        //     description:
        //         "Kufri Zoo is a must-visit for animal lovers and families. It houses various species, including the rare Himalayan Monal, along with other animals like bears and deer. The zoo is well-maintained and provides a natural habitat for the animals, allowing visitors to learn about their behaviors and conservation efforts. Kids will particularly enjoy seeing the animals up close and engaging with educational exhibits. A trip to Kufri Zoo is both fun and informative!",
        //     image: "/images/experience/kufri.png",
        //     alt: "Kufri Zoo",
        //     textFirst: true,
        // },
        {
            title: "Indira Gandhi Tourist Park",
            description: "Indira Gandhi Tourist Park is a popular picnic spot located near Kufri. Known for its serene atmosphere and lush greenery, this park is a great place to unwind and enjoy the natural surroundings. It offers expansive lawns, shaded areas, and stunning views of the surrounding mountains. Families and groups of friends often visit the park to relax, take leisurely walks, or enjoy a picnic amidst nature. It’s an ideal destination for those looking for peace and scenic beauty.                ",
            image: "/images/experience/indira-gandhi-tourist-park.png",
            alt: "Indira Gandhi Tourist Park",
            textFirst: true
        },
        {
            title: "Green Valley",
            description: "Green Valley is a breathtaking viewpoint located on the way to Kufri, offering stunning panoramic views of the surrounding hills and dense pine forests. As the name suggests, the valley is covered with lush greenery, making it an ideal stop for photography enthusiasts and nature lovers. The fresh air and scenic beauty are perfect for a quick break during your journey to Kufri. Green Valley is also home to various wildlife species, which can occasionally be spotted in the distance.",
            image: "/images/experience/green-valley-kufri.jpg",
            alt: "Green Valley",
            textFirst: false
        }
    ];
    const thingsToDo = [
        {
            icon: "/icons/kufri-fun-world.svg",
            title: "Visit Adventure Resorts"
        },
        {
            icon: "/icons/snow-kingdom.svg",
            title: "Enjoy Snow Any-month at Snow Kingdom Kufri"
        },
        {
            icon: "/icons/skiing-in-winter.svg",
            title: "Enjoy Skiing in Winter"
        },
        {
            icon: "/icons/horse-riding.svg",
            title: "Horse Riding"
        },
        {
            icon: "/icons/national-park.svg",
            title: "Visit the Himalayan Nature Park"
        },
        {
            icon: "/icons/yak-ride.svg",
            title: "Yak Ride"
        },
        {
            icon: "/icons/mahasu-peak.svg",
            title: "Visit Mahasu Peak"
        },
        {
            icon: "/icons/tobagganing.svg",
            title: "Enjoy Tobogganing in Winter"
        },
        {
            icon: "/icons/kufri-zoo.svg",
            title: "Visit Kufri Zoo"
        }
    ];
    const activities = [
        {
            title: "Sky Swinger",
            bgImage: "/images/sky-swinger.png",
            description: "Sky Swinger is a new way to experience the sky. As an aerial playground, Sky Swinger offers thrilling opportunities for people to experience the rush of adrenaline."
        },
        {
            title: "Go Kart",
            bgImage: " /images/karting-attra.png",
            description: "Go-karts are the ultimate way to channel your inner child. We know you've got the skills and the moves, but it's time to get out of your comfort zone with Go Karting."
        },
        {
            title: "Zip Line",
            bgImage: "/images/zip-line.webp",
            description: "Zipline offers a unique, exhilarating experience you'll never forget. Our expert instructors help participants feel secure during the flight."
        },
        {
            title: "Bungee Injection",
            bgImage: "/images/bungee.png",
            description: " Bungee Injection is a new adventure activity that combines one of the most adrenaline-pumping experiences in the world with a fun, friendly environment."
        },
        {
            title: "Indoor activities",
            bgImage: "/images/outdoor.jpg",
            description: "At Adventure Resorts, we have a wide variety of indoor activities to keep you entertained. We have dashing cars, haunted house, 5D theater and much more. You will never feel bored."
        }
    ];
    const faqsData = [
        {
            accordionQuestion: "What are the top attractions in Kufri?",
            accordionAnswer: "Kufri offers several attractions, including Mahasu Peak, Snow Kingdom Kufri, and Kufri Zoo. Each location provides unique experiences, from stunning views to exciting activities.",
            id: 1
        },
        {
            accordionQuestion: "How do I reach Kufri from Shimla?",
            accordionAnswer: "Kufri is approximately 16 kilometers from Shimla and can be reached by taxi or bus in about 30 minutes. The scenic drive through the hills is enjoyable and a great way to start your adventure.",
            id: 2
        },
        {
            accordionQuestion: "What outdoor activities are available in Kufri?",
            accordionAnswer: "Kufri is known for its outdoor adventures, such as trekking, zip-lining, and skiing in winter. Adventure Resorts Kufri is an excellent place to try activities like bungee ejection, sky swinger, Rope Course, Go-Karting, and such types of activities.",
            id: 3
        },
        {
            accordionQuestion: "Can I find accommodation near popular attractions in Kufri?",
            accordionAnswer: "Yes, The Twin Towers Hotel is conveniently located near major attractions in Kufri, making it an ideal place to stay while exploring the area. The hotel offers comfortable rooms and easy access to local sights.",
            id: 4
        },
        {
            accordionQuestion: "What is the best time to visit Kufri?",
            accordionAnswer: "Kufri is a year-round destination. The best time to visit depends on your preferences: winter for snow activities, summer for pleasant weather, and autumn for beautiful landscapes.",
            id: 5
        }
    ];
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const [loader, setLoader] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false);
    const [noOfNights, setNoOfNights] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(router.query.npOfNights || 1);
    const [startDate, setStartDate] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(new Date());
    const [endDate, setEndDate] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(()=>{
        const tomorrow = (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(new Date(), 1);
        return tomorrow;
    });
    const [checkin, setCheckin] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)({
        day: router.query.checkinDay || "",
        month: router.query.checkinMonth || "",
        year: router.query.checkinYear || ""
    });
    const [checkout, setCheckout] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)({
        day: router.query.checkoutDay || "",
        month: router.query.checkoutMonth || "",
        year: router.query.checkoutYear || ""
    });
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(()=>{
        const updateDateState = (date, setStateFunction)=>{
            if (date !== null) {
                const day = date.getDate();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const year = date.getFullYear();
                setStateFunction({
                    day,
                    month,
                    year
                });
            }
        };
        updateDateState(startDate, setCheckin);
        updateDateState(endDate, setCheckout);
        const nights = moment__WEBPACK_IMPORTED_MODULE_9___default()(endDate).diff(moment__WEBPACK_IMPORTED_MODULE_9___default()(startDate), "days");
        setNoOfNights(nights > 0 ? nights : 1);
    }, [
        startDate,
        endDate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(()=>{
        const nights = (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(endDate, startDate);
        setNoOfNights(nights);
    }, [
        startDate,
        endDate
    ]);
    const formated_start_date = moment__WEBPACK_IMPORTED_MODULE_9___default()(startDate).format("YYYY-MM-DD");
    const formated_end_date = moment__WEBPACK_IMPORTED_MODULE_9___default()(endDate).format("YYYY-MM-DD");
    const handleSubmit = async (event, hotelId)=>{
        event.preventDefault();
        setLoader(true);
        try {
            await router.push("/searchresults/?hotelID=".concat(hotelId, "&checkinDay=").concat(checkin.day, "&checkinMonth=").concat(checkin.month, "&checkinYear=").concat(checkin.year, "&checkoutDay=").concat(checkout.day, "&checkoutMonth=").concat(checkout.month, "&checkoutYear=").concat(checkout.year, "&room=1&adult=2&children=0&checkIn=").concat(formated_start_date, "&checkOut=").concat(formated_end_date, "&noOfNights=").concat(noOfNights), undefined, {
                shallow: false
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally{
            setLoader(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Things to Do and Experiences in Kufri Shimla"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Things to Do and Experiences Kufri Shimla, Live Barbeque, Bonfire, Jungle Walk, Jungle Safari, | The Twin Towers Hotel in Shimla"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/experiences"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().single_blog_top_banner)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().experiences_sec), " common_padding"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().experience_page_heading), " mb-4"),
                            children: "PLACES TO VISIT IN KUFRI"
                        }),
                        experiences && (experiences === null || experiences === void 0 ? void 0 : experiences.map((experience, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().experiences_main), " row"),
                                children: experience.textFirst ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().experiences_text)),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "common_title",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                        children: [
                                                            index + 1,
                                                            ". ",
                                                            experience.title
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: experience.description
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().experiences_image), " col-md-4 first-order-mobile"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: experience.image,
                                                alt: experience.alt
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().experiences_image)),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: experience.image,
                                                alt: experience.alt
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().experiences_text)),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "common_title",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                        children: [
                                                            index + 1,
                                                            ". ",
                                                            experience.title
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: experience.description
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }, index)))
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().adventure_snow_kingdom_sec)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().other_places_heading),
                            children: "there are more places to visit in shimla"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().adventure_snow_kingdom_sec_row),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().adventure_snow_kingdom_sec_row_text),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: "Adventure Resorts"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: "A Complete Tourist Destination"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().para_cont),
                                            children: "Adventure Resorts Kufri is a must-visit destination for thrill-seekers and nature lovers. This resort offers a variety of outdoor activities such as zip-line, bungee ejection, sky swinger, and go-karting. Whether you’re traveling solo, with friends, or with family, these activities promise an adrenaline-filled adventure while allowing you to appreciate the stunning natural beauty around you. With comfortable accommodations and delightful dining options, Adventure Resorts Kufri is perfect for creating unforgettable memories in the heart of the mountains."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlights),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item_icon),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                src: "/icons/adventure-activities.svg",
                                                                height: 35,
                                                                width: 35,
                                                                alt: "Adventure Activities"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Adventure Activities"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item_icon),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                src: "/icons/safe-adventure.svg",
                                                                height: 35,
                                                                width: 35,
                                                                alt: "Safe Adventure Spot"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Safe Adventure Spot"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item_icon),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                src: "/icons/perfect-family.svg",
                                                                height: 35,
                                                                width: 35,
                                                                alt: "Perfect for Families"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Perfect for Families"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: "https://www.adventureresortkufri.com/",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "common_btn",
                                            children: "Know More"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().adventure_snow_kingdom_sec_row_image), " ").concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().mobile_first)),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/images/experience-adventure-resort.png",
                                        alt: "adventure-resort"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().adventure_snow_kingdom_sec), " common_padding"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().adventure_snow_kingdom_sec_row),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().adventure_snow_kingdom_sec_row_image),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/experience-snow-kingdom.png",
                                    alt: "Snow kingdom kufri"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().adventure_snow_kingdom_sec_row_text),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        children: "Snow kingdom kufri"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        children: "Your Snowy Escape in the Heart of Himachal"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().para_cont),
                                        children: "Snow Kingdom Kufri is a magical destination for winter lovers, situated at a height of 8,800 feet. As the largest snow park in Himachal Pradesh, it spans over 12,000 square feet and offers a unique experience for visitors. You can enjoy thrilling snowball fights, snow tubing, and sledding, all while surrounded by towering snow structures that reach up to 30 feet. This snow paradise ensures that the fun continues year-round, making it a favorite spot for families and winter sports enthusiasts alike."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlights),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item_icon),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            src: "/icons/yearround-destination.svg",
                                                            height: 35,
                                                            width: 35,
                                                            alt: "Year Ruund Desination"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "Year-Round Destination"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item_icon),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            src: "/icons/child-friendly.svg",
                                                            height: 35,
                                                            width: 35,
                                                            alt: "Child Friendly"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "Child-Friendly"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().highlight_item_icon),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            src: "/icons/snow-paradise.svg",
                                                            height: 35,
                                                            width: 35,
                                                            alt: "Snow Paradise"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "Snow Paradise"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "https://www.snowkingdomkufri.com/",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "common_btn",
                                        children: "Know More"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().things_to_do)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().experience_page_heading), " mb-4"),
                            children: "THINGS TO DO IN KUFRI"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().things_to_do_main),
                            children: thingsToDo && thingsToDo.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().things_to_do_item),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().things_to_do_item_icon),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                src: item.icon,
                                                width: 55,
                                                height: 55,
                                                alt: item.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().things_to_do_item_text),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                children: item.title
                                            })
                                        })
                                    ]
                                }, index))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "common_padding",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "".concat((_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().experience_page_heading), " mb-2"),
                            children: "FAQs"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Faqs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            faqsData: faqsData
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().blog_footer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().blog_footer_content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            children: "Your Perfect Stay Awaits"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: (_styles_pages_Experiences_module_scss__WEBPACK_IMPORTED_MODULE_12___default().blog_page_btn),
                            onClick: (event)=>handleSubmit(event, 17),
                            children: "Book Now"
                        })
                    ]
                })
            })
        ]
    });
} // {
 //     title: "Jungle Walk",
 //     description:
 //         "Nothing beats an early morning forest walk. It is worth going for an early morning jungle walk - the air is so cool and refreshing. A hamper breakfast in the middle of the jungle is indeed no match. It is about a 5 km walk, passing through the thick cedar jungle of Kufri.",
 //     image: "/images/jungle-walk.png",
 //     alt: "Jungle Walk Image",
 //     textFirst: false,
 // },
 // {
 //     title: "Bonfire",
 //     description:
 //         "Gather around our bonfire pit with your friends and family to enjoy the warmth and ambiance of the flames. Roast marshmallows, make s'mores, and snuggle up with blankets as you watch the stars above. The crackling sounds of the fire and the warmth of the bonfire will create lasting memories with your loved ones.",
 //     image: "/images/bonfire.png",
 //     alt: "Bonfire Image",
 //     textFirst: true,
 // },
 // {
 //     title: "Live Barbeque",
 //     description:
 //         "To enjoy the luxury of grilling, simply select items from our menu. Our chef will grill the marinated items of your choice and you can enjoy your party or family dine-in with smoky flavors.",
 //     image: "/images/barbeque.png",
 //     alt: "Barbeque Image",
 //     textFirst: false,
 // },
 // {
 //     title: "Jungle Safari",
 //     description:
 //         "Jeep Safari is one of the best ways to explore unexplored places. Off-road safaris provide you with a unique and exciting experience. It takes you through adventurous and uncommon routes where you can observe rare species of flora and fauna. On our Safari tour, the road passes through dense pine forests, with trees soaring up 20 meters. Road hazards include flocks of sheep, traditionally dressed village women and men, and wild animals, etc. Through the 15 km off-road journey, you will have a very different day out with the nature of the jungle.",
 //     image: "/images/jungle-safari.png",
 //     alt: "Jungle Safari Image",
 //     textFirst: true,
 // },


/***/ }),

/***/ 9262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};

/***/ }),

/***/ 8041:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"experiences_sec":"Experiences_experiences_sec__0_ujN","experiences_main":"Experiences_experiences_main__ncPJj","experiences_image":"Experiences_experiences_image__z_gqP","experiences_text":"Experiences_experiences_text__RtrCr","things_to_do":"Experiences_things_to_do__Zh2MW","things_to_do_main":"Experiences_things_to_do_main__1VnwV","things_to_do_item":"Experiences_things_to_do_item__aCK_5","things_to_do_item_icon":"Experiences_things_to_do_item_icon__mPGsP","things_to_do_item_text":"Experiences_things_to_do_item_text__SjHGQ","activities_sec":"Experiences_activities_sec__ZGiER","activities_slider":"Experiences_activities_slider__FU_oW","activity_child":"Experiences_activity_child__Q51kE","activity_bg_image":"Experiences_activity_bg_image__Gx8mJ","activity_overlay":"Experiences_activity_overlay__MOfcr","explore_btn":"Experiences_explore_btn__1Xfsj","experience_page_heading":"Experiences_experience_page_heading__pcKe2","adventure_snow_kingdom_sec":"Experiences_adventure_snow_kingdom_sec__XG_32","adventure_snow_kingdom_sec_row":"Experiences_adventure_snow_kingdom_sec_row___wK4U","adventure_snow_kingdom_sec_row_text":"Experiences_adventure_snow_kingdom_sec_row_text__WFDqU","para_cont":"Experiences_para_cont__oTXYQ","highlights":"Experiences_highlights__nH3JX","highlight_item":"Experiences_highlight_item__2di1V","highlight_item_icon":"Experiences_highlight_item_icon__VLcZB","adventure_snow_kingdom_sec_row_image":"Experiences_adventure_snow_kingdom_sec_row_image__l2syZ","mobile_first":"Experiences_mobile_first__KW5W0","blog_footer":"Experiences_blog_footer__Gu_FI","blog_footer_content":"Experiences_blog_footer_content__OSrYJ","blog_page_btn":"Experiences_blog_page_btn__R4r7X","single_blog_top_banner":"Experiences_single_blog_top_banner__kse7R","other_places_heading":"Experiences_other_places_heading__0xoud"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9774,2888,179], function() { return __webpack_exec__(4796); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);